import { useEffect, useRef, useState } from "react";
import Avatar from "../NumberOptions/Avatar";
import SearchIcon from "../SvgIcons/Iconsearchbar";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import api from "../../services/axios";
import { useAuth } from "../../context/AuthContext";
import IconTickets from "../SvgIcons/IconTickets";

export default function GlobalSearch() {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const [recentticket, setRecentTicket] = useState([]);
  const [contacts, setContacts] = useState([]);
  const { authUser } = useAuth();
  const [recentSearch, setRecentSearch] = useState([]);
  const [recentVisited, setRecentVisited] = useState([]);
  const [visible, setVisiblity] = useState(true);
  const [noResults, setNoResults] = useState(false);
  let timeoutId = useRef(null);

  const closePopup = () => setIsOpen(false);

  useEffect(() => {
    clearTimeout(timeoutId.current);

    if (searchTerm.trim().length >= 4) {
      timeoutId.current = setTimeout(() => {
        searchValue();
      }, 500);
    } else if (searchTerm.trim().length === 0) {
      // 👇 Reset to stored values from localStorage
      const storedSearch = JSON.parse(localStorage.getItem("recentSearch") ?? "[]");
      const storedVisited = JSON.parse(localStorage.getItem("recentVisited") ?? "[]");

      setRecentSearch(storedSearch);
      setRecentVisited(storedVisited);
      setRecentTicket([]);
      setContacts([]);
      setVisiblity(true);
    }
    const savedVisited = localStorage.getItem("recentVisited");
    if (savedVisited) {
      setRecentVisited(JSON.parse(savedVisited));
    }

    return () => clearTimeout(timeoutId.current);
  }, [searchTerm]);


  const searchValue = async () => {
    try {
      const response = await api.post("/globalSearch", {
        searchTerm: searchTerm,
      });

      const tickets = response.data?.data?.tickets ?? [];
      const customers = response.data?.data?.customer_list ?? [];

      const hasResults = (tickets.length > 0 || customers.length > 0) && searchTerm.trim();

      if (hasResults) {
        setVisiblity(false);
        setNoResults(false); // ✅ reset
        setRecentTicket(tickets);
        setContacts(customers);

        const stored = JSON.parse(localStorage.getItem("recentSearch") ?? "[]");
        if (!stored.includes(searchTerm)) {
          const updated = [...stored, searchTerm].slice(-5);
          localStorage.setItem("recentSearch", JSON.stringify(updated));
          setRecentSearch(updated);
        }
      } else {
        // Fallback to recent search and visited
        const allSearch = JSON.parse(localStorage.getItem("recentSearch") ?? "[]");
        const allVisited = JSON.parse(localStorage.getItem("recentVisited") ?? "[]");

        const filteredSearch = allSearch.filter(item =>
          item.toLowerCase().includes(searchTerm.toLowerCase())
        );

        const filteredVisited = allVisited.filter(item => {
          const key = Object.keys(item)[0];
          return key.toLowerCase().includes(searchTerm.toLowerCase());
        });

        setRecentSearch(filteredSearch);
        setRecentVisited(filteredVisited);
        setRecentTicket([]);
        setContacts([]);
        setVisiblity(true);
        setNoResults(filteredSearch.length === 0 && filteredVisited.length === 0);
      }
    } catch (err) {
      console.error("Search failed:", err);
      setNoResults(true); // fallback in case of error
    }
  };



  useEffect(() => {
    if (searchTerm.length >= 4) {
      clearTimeout(timeoutId.current);
      timeoutId.current = setTimeout(() => {
        searchValue();
      }, 500);
    }
    else {
      setVisiblity(true);
      setRecentTicket([])
      setContacts([])
    }

    return () => clearTimeout(timeoutId.current);
  }, [searchTerm]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
        // Remove setSearchTerm("") if you want to keep the last search
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
    }
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen]);

  return (
    <div className="mainsearch" ref={dropdownRef}>
      <div className="searchbarsenter position-relative w-100">
        <div className="searchbar">
          <span>
            <SearchIcon />
          </span>
          <input
            className="form-control"
            placeholder="Type to search"
            value={searchTerm}
            onFocus={() => setIsOpen(true)}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <>
            <div className="searchbarresult">
              <div className="topsearchbarmain position-absolute w-100">
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsOpen(false)}
                >
                </button>
                <div className="dropdownsearchbar position-relative">
                  <span>
                    <SearchIcon />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="innersearchscroll d-flex flex-column gap-3">
                  <div className="innersearchscroll">
                    {recentSearch?.length > 0 && visible && (
                      <Section title="Recent search" height={300}>
                        {recentSearch.map((item, i) => (
                          <Item key={i} label={item} onClick={() => setSearchTerm(item)} />
                        ))}
                      </Section>
                    )}

                    {(recentVisited.length > 0 && visible) && (
                      <Section title="Recently visited" height={300}>
                        {recentVisited.map((item, i) => (
                          <Item
                            key={i}
                            label={Object.keys(item)[0] + ' - ' + item[Object.keys(item)[0]]}
                            link={item[Object.keys(item)[0]]}
                            onClick={closePopup}
                          />

                        ))}
                      </Section>
                    )}

                    {(recentticket?.length > 0) && (
                      <Section title="Tickets" height={320}>
                        {recentticket.map((ticket, i) => (
                          <Item
                            key={i}
                            label={ticket.Ticket_No + ' - ' + ticket.Contact_Person}
                            type="ticket"
                            link={`/view-ticket-history/${ticket.Ticket_No}`}
                            onClick={closePopup}
                          />

                        ))}
                      </Section>
                    )}

                    {contacts?.length > 0 && (
                      <Section title="Recent Customers" height={320}>
                        {contacts.map((c, i) => (
                          <Item
                            key={i}
                            label={c.Customer_Name}
                            link={`/edit-customer-details/${encodeURIComponent(c.Code)}`}
                            onClick={closePopup}
                          />

                        ))}
                      </Section>
                    )}

                    {noResults && (
                      <div className="text-center text-muted py-3">
                        No data found.
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
            {noResults && (
              <div className="text-center text-muted py-3">
                No data found.
              </div>
            )}</>
        )}</AnimatePresence>
    </div>
  );
}

// Section Component
function Section({ title, children, height = 150 }) {
  return (
    <div className="d-flex flex-column gap-1">
      <div className="serchbarheading px-3">{title}</div>
      <div
        className="d-flex flex-column section-scroll px-2"
      //style={{ maxHeight: height, overflowY: "auto" }}
      >
        {children}
      </div>
    </div>
  );
}

// Reusable Item
function Item({ label, type, link, onClick }) {
  const content = (
    <div
      className="list-group-item d-flex align-items-center gap-2"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      {type === "ticket" ? (
        <span className="text-muted">
          <IconTickets />
        </span>
      ) : (
        <Avatar name={label} width={24} height={24} fontSize={10} />
      )}
      <span className="text-truncate group-item-text">{label}</span>
    </div>
  );

  return link ? (
    <Link to={link} onClick={onClick}>
      {content}
    </Link>
  ) : (
    content
  );
}
